import i18n from 'i18next';
import React, { useEffect, useMemo, useState } from 'react';
import { ButtonGroup } from 'primereact/buttongroup';
import User from '../../../interfaces/user';
import AXButton from './ax-button';

const SwitchLang = ({ user }: { user: User | undefined }) => {
  const languages: string[] = useMemo(() => ['fr', 'en'], []);
  const [currentLanguage, setCurrantLanguage] = useState<string | null>(null);
  const changeLanguage = (lng: string) => {
    setCurrantLanguage(lng);
    i18n.changeLanguage(lng);
  };

  useEffect(() => setCurrantLanguage(i18n.languages[0]), [currentLanguage]);

  if (!user || user?.dataLocation !== 'dev') return <></>;

  return (
    <div className="container">
      <hr className="text-gray-300 mb-2" />
      <ButtonGroup aria-label="Languages">
        {languages.map((lang) => {
          return (
            <AXButton
              key={lang}
              {...(currentLanguage?.includes(lang) ? { active: 'true' } : '')}
              label={`button.${lang}`}
              onClick={() => changeLanguage(lang)}
              testid={`switch_${lang}_button`}
            />
          );
        })}
      </ButtonGroup>
    </div>
  );
};

export default SwitchLang;
